export default "__VITE_ASSET__5$sevU9Dyn7xl0c_7zlKpg__";